module.exports = __webpack_public_path__ + "fonts/HelveticaRegular.19f21ee.woff2";